import $ from 'jquery';
import Inputmask from 'inputmask';
import { BaseMask } from './base.mask';
import * as CONST from '../constants';
import masks from '../masks';
import { inputmaskFormat } from '../utils/inputmaskFormat';

const DEFINITIONS = {
    '#': { validator: '[0-9]', cardinality: 1, casing: 'lower' },
    '^': { validator: '[\\s\\-]', cardinality: 1, casing: 'lower' },
};

export class PostalMask extends BaseMask {
    getClassConstructor() {
        return PostalMask;
    }
    getConfig() {
        return CONST.POSTAL_CONFIG;
    }

    getInvalidMsg() {
        return CONST.INVALID_POSTAL_NUMBER_MSG;
    }

    getInvalidMsgAttr() {
        return CONST.INVALID_POSTAL_MSG_DATA_ATTR;
    }

    isCountryAvailableForMask(countryCode) {
        return countryCode === 'US';
    }

    static maskMethod(value, element) {
        const im = $(element).data('im');
        const $hintMessageBlock = $('span.postal-format');

        // if focused - skip validation
        if ($(element).is(':focus')) {
            $(element).removeClass('error');
            $(element)
                .siblings('.error-tooltip')
                .addClass('hidden');

            $(element).on('blur', () => {
                $(element)
                    .siblings('.error-tooltip')
                    .removeClass('hidden');
            });
            $hintMessageBlock.removeClass('hidden');
            return true;
        }

        // if focused out - start validation
        // check if mask valid and complete
        // NB: isValid, isComplete - methods of inputMask plugin
        const val = im.format(value);
        const isComplete = im.isComplete(val);
        const originalBuffer = [].concat(im.maskset.buffer);
        // NB: somehow isValid mutates current buffer and does not respect
        // clearMaskOnLostFocus value. after isValid called, placeholder symbols
        // removed from the buffer.
        // Fix in the original code is not possible due to a lot of tests and possibly
        // other code relies on this behaviour
        const isValid = im.isValid(val);
        im.maskset.buffer = originalBuffer;

        if (!isComplete || !isValid) {
            $(element).addClass('error');
            $(element)
                .siblings('.error-tooltip')
                .removeClass('hidden');
            $hintMessageBlock.addClass('hidden');

            return false;
        }

        $(element).removeClass('error');
        $(element)
            .siblings('.error-tooltip')
            .addClass('hidden');
        $hintMessageBlock.removeClass('hidden');

        return true;
    }
    static getDefinitions() {
        return DEFINITIONS;
    }
    static adjustView(countryCode, element) {
        if (countryCode !== 'US') return;
        const maskConfig = masks[countryCode.toUpperCase()].postal;

        const postal = $(element)
            .find(CONST.VIEW_MODE_POSTAL_FIELD_SELECTOR)
            .text();
        let maskedPostal = '';
        if (maskConfig.mask) {
            maskedPostal = inputmaskFormat(
                postal,
                { mask: maskConfig.mask },
                PostalMask.getDefinitions(),
            );
        } else if (maskConfig.regex) {
            maskedPostal = Inputmask.format(postal, {
                regex: maskConfig.regex,
            });
        }
        const isFormatedFieldValid = maskedPostal && maskedPostal.indexOf('_') <= 0;
        if (isFormatedFieldValid) {
            $(element)
                .find(CONST.VIEW_MODE_POSTAL_FIELD_SELECTOR)
                .html(maskedPostal);
        }
    }
}

PostalMask.MASK_NAME = CONST.MASKED_POSTAL_DEFINITION;
